var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRightArrowLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4225 6.9905C10.4245 6.932 10.396 6.884 10.305 6.7935L4.59352 1.0825C4.53352 1.0275 4.47902 1 4.42552 1C4.37202 1 4.31902 1.0275 4.26252 1.082C4.10502 1.234 3.95102 1.3895 3.79702 1.545L3.65852 1.6845C3.60252 1.7405 3.58002 1.794 3.58252 1.863C3.58552 1.93 3.62602 1.9825 3.70452 2.061L4.91202 3.268C6.08252 4.4385 7.25302 5.6085 8.42552 6.7775C8.48102 6.8325 8.53702 6.9025 8.53702 7.002C8.53752 7.1025 8.47852 7.174 8.42752 7.225C7.08902 8.5585 5.75352 9.8945 4.41802 11.2305L3.69902 11.9495C3.53652 12.112 3.53702 12.196 3.69952 12.36L4.23652 12.8975C4.28152 12.9425 4.31702 12.9735 4.35402 12.9865C4.43802 13.0165 4.50902 13.0085 4.63852 12.8785L10.3035 7.2125C10.3325 7.1835 10.358 7.158 10.3795 7.1305C10.4125 7.0895 10.426 7.052 10.4235 7.008L10.423 6.9995L10.4225 6.9905Z",
    fill: "#5A577A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRightArrowLine);
export default __webpack_public_path__ + "static/media/icon-right-arrow-line.2d264c087b33c434db5f8cc5a5897b88.svg";
export { ForwardRef as ReactComponent };